import Vue from 'vue'
import Vuex from 'vuex'
import createMainModule from '72cms-ui/store/modules/main'
import createSubModule from '72cms-ui/store/modules/sub'
import createAssetsModule from '72cms-ui/store/modules/assets'
import createPagePanelsModule from '72cms-ui/store/modules/panels'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default (helpers) => {

    return Promise.all([
        createMainModule(helpers),
        createSubModule(helpers),
        createAssetsModule(helpers),
        createPagePanelsModule(helpers),
    ])
    .then(([main, sub, assets, panels]) => {
        return new Vuex.Store({
            modules: {
                main, sub, assets, panels,
            },
            strict: debug,
        })
    })
}




// WEBPACK FOOTER //
// ./resources/assets/cms/js/store.js